import { getNumberFormat } from '~/cynqueModules/getNumberFormat'

// Module-level constant so getNumberFormat() takes its identity path — see the
// header there.
const PERCENT_OPTIONS: Intl.NumberFormatOptions = {
  style: 'percent',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $formatPercentage(amount: number | string | undefined | null): string
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.globalProperties.$formatPercentage = (
    amount: number | string | undefined | null
  ) => {
    if (amount === undefined || (typeof amount === 'string' && amount === '')) {
      return '--'
    }
    if (amount === null) {
      return '--' // was return ''. Not sure why I did that. JR.
    }
    if (amount === 0) {
      return '0%'
    }
    if (typeof amount === 'string') {
      return amount
    }

    return getNumberFormat('en-US', PERCENT_OPTIONS).format(amount)
  }
})
